import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from "recharts";
import AnalyticsEmptyState from "../../dashboard/AnalyticsEmptyState";
import { CHART_MARK_STROKE, CHART_MARK_STROKE_WIDTH } from '../../../helpers/chartPalette';

const ParagraphDevelopmentBarChart = ({ rawData, totalResponses, graphColor }) => {
  if (!rawData || rawData.length === 0) {
    return <AnalyticsEmptyState />;
  }

  // Transform data to a usable format for Recharts
  const processData = (data) => {
    return (
      data &&
      data.map((item) => {
        const transformed = { MomentName: item.MomentName };
        item.Categories.forEach((category) => {
          transformed[category.Title] = category.Words;
        });
        return transformed;
      })
    );
  };

  // Extract unique dynamic keys and their associated colors
  const categories =
    rawData &&
    rawData.flatMap((item) =>
      item.Categories.map((category) => ({
        title: category.Title,
        color: category.Color,
      }))
    );

  const uniqueCategories = Array.from(
    new Map(categories.map((cat) => [cat.title, cat])).values()
  );

  // Transformed data
  const data = processData(rawData);

  return (
    <>
     <BarChart
      width={600}
      height={300}
      data={data}
      margin={{
        top: 5,
        right: 30,
        left: 20,
        bottom: 5,
      }}
    >
      <XAxis
      dataKey="MomentName"
      axisLine={false}
      tickLine={false}
      stroke={graphColor || 'black'}
      tick={{ fill: graphColor || undefined }} />
      <YAxis
      axisLine={false}
      tickLine={false}
      stroke={graphColor || 'black'}
      tick={{ fill: graphColor || undefined }} />
      <Tooltip />
      <Legend wrapperStyle={{ color: graphColor || undefined }} />
      {uniqueCategories.map((category, index) => (
        <Bar
          key={category.title}
          dataKey={category.title}
          fill={category.color} // Use color from rawData
       stroke={CHART_MARK_STROKE} strokeWidth={CHART_MARK_STROKE_WIDTH} />
      ))}
    </BarChart>
    </>

  );
};

export default ParagraphDevelopmentBarChart;
